import { getCookies } from "./Utility";
import axios from "./axios";

export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    const tenant_id = getCookies("tenant-id");
    formData.append('tenant_id', tenant_id);
    formData.append('file', file);
    const response = await axios.post('/uploads',
      formData,
    );
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};
